import { string, type ZodType } from 'zod';
import { normalizeWhitespace } from 'common/utils/string.utils';

export function optionalNormalizedString(): ZodType<string | undefined> {
  return string().trim().transform(normalizeWhitespace).optional();
}

export function requiredNormalizedString(errorMessage: string): ZodType<string> {
  return string()
    .transform(normalizeWhitespace)
    .refine((val) => val.length > 0, errorMessage);
}
